import React, {useState} from 'react';
import {TimedText} from "@energy-advice/alertfan-api-client";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {dateToReadableString} from "utils/time-utils";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";

type TransposedArrayTableType = {
    properties: Array<TimedText>
}

const TransposedArrayTable = ({properties}: TransposedArrayTableType) => {
    const [dialog, setDialog] = useState(false)

    return <>
        {properties && properties.length > 0 &&
            <Button icon={"pi pi-bars"} tooltip={"Previous Texts"} className={"p-button-sm"} onClick={() => setDialog(true)}></Button>
        }
        {dialog &&
            <Dialog onHide={() => setDialog(false)} visible={dialog} header={"Previous Texts"} style={{width: "400px"}}>
                <DataTable value={properties} removableSort size={"small"}>
                    <Column header={"Time"}
                            body={(e: TimedText) => e.time ? dateToReadableString(new Date(e.time)) : "-"}
                            style={{whiteSpace: "nowrap"}}
                    ></Column>
                    <Column header={"Text"} field={"text"}></Column>
                </DataTable>
            </Dialog>
        }
    </>
};

export default TransposedArrayTable;